import { colors } from '@material-ui/core'

const WHITE = '#FFFFFF'
const BLACK = '#000000'
const ACOLAD_DARK_BLUE = '#0b1c34'
export const ACOLAD_BLUE = '#126cee'
const ACOLAD_LIGHT_BLUE = '#acdeef'
export const ACOLAD_YELLOW = '#E6BC56'
export const DARKER_ACOLAD_YELLOW = '#cdaa4e'
export const ACOLAD_SOFT_GREY = '#b4b5b6'
export const ACOLAD_YELLOW_BORDER = '#E5BC55'
export const ACOLAD_ROW_HOVER_COLOR = '#F2FAFC'
export const ACOLAD_FORM_ERROR = '#E53935'
const ACOLAD_GREEN = '#008704'

export default {
    black: BLACK,
    white: WHITE,
    primary: {
        contrastText: WHITE,
        dark: colors.blueGrey[900],
        main: ACOLAD_DARK_BLUE,
        light: colors.blueGrey[100],
    },
    secondary: {
        contrastText: WHITE,
        dark: colors.blueGrey[800],
        main: colors.blueGrey[800],
        light: colors.blueGrey[500],
    },
    error: {
        contrastText: WHITE,
        dark: colors.red[900],
        main: colors.red[600],
        light: colors.red[400],
    },
    text: {
        primary: colors.blueGrey[900],
        secondary: colors.blueGrey[600],
        link: colors.indigo[800],
    },
    link: colors.indigo[800],
    icon: colors.blueGrey[600],
    background: {
        default: '#223349',
        paper: '#f5f5f5',
    },
    divider: colors.grey[200],
    acolad: {
        yellow: ACOLAD_YELLOW,
        lightBlue: ACOLAD_LIGHT_BLUE,
        blue: ACOLAD_BLUE,
        darkBlue: ACOLAD_DARK_BLUE,
    },
    textGrey: '#7a7d7f',
    lightGrey: '#f8f8f8',
    border: '#eeeeee',
    status: {
        quoting: ACOLAD_LIGHT_BLUE,
        translation: '#82B3C4',
        clientReviewLqa: ACOLAD_YELLOW,
        revisionLqa: '#F8DA91',
        signOff: '#0A1C35',
        cancelled: '#E1E4E6',
        completed: ACOLAD_GREEN,
        financialApproval: '#9E9B54',
        editing: '#3D8CC0',
        review: '#4E93DE',
        inProgress: '#007BFF',
        comingDue: '#FFC107',
        pastDue: '#DC3545',
    },
    tempoStatus: {
        requested: ACOLAD_SOFT_GREY,
        pending: ACOLAD_YELLOW,
        inProgress: '#82B3C4',
        completed: ACOLAD_GREEN,
        cancelled: '#E1E4E6',
        noStatus: '#E1E4E6',
        draft: ACOLAD_SOFT_GREY,
        analyzing: ACOLAD_SOFT_GREY,
    },
    footer: ACOLAD_LIGHT_BLUE,
    header: ACOLAD_LIGHT_BLUE,
}
